import { BehaviorSubject, Observable } from 'rxjs';

export class RequestQueue<T> {
    private _queue: Promise<T | void>;
    private _queueCount: number;
    private _isLoading: BehaviorSubject<boolean>;
    private _isComplete:boolean = false;

    public get queueCount(): number {
        return this._queueCount;
    }

    public get isLoading(): boolean {
        return this._isLoading.value;
    }

    public get isLoadingObservable(): Observable<boolean> {
        return this._isLoading.asObservable();
    }

    constructor(initialValue?: T) {
        this._queue = Promise.resolve(initialValue);
        this._queueCount = 0;
        this._isLoading = new BehaviorSubject<boolean>(false);
    }

    enqueue = (request: () => Promise<T>): Promise<T | void> => {
        if (!this._isComplete) {
            this._queueCount++;
            this._isLoading.next(true);
            this._queue = this._queue
                .then(() => request())
                .catch(() => {})
                .finally(() => this.dequeue());
        }

        return this._queue;
    }

    generateAndEnqueRequest = (action: () => Promise<T>): Promise<T> => {
        return new Promise<T>((resolve, reject) => {
            const request = this.generateRequest(resolve, reject, action);
            this.enqueue(request);
        });
    }

    private generateRequest = (
        resolve: (value: T | PromiseLike<T>) => void,
        reject: (reason?: any) => void,
        action: () => Promise<T>
    ): () => Promise<T> => () =>
        action()
        .then(value => {
            resolve(value);
            return value
        }).catch(reason => {
            reject(reason);
            throw reason;
        })

    complete = () => {
        this._isComplete = true;
        this._isLoading.complete();
    }

    private dequeue = () => {
        this._queueCount--;
        if (this.queueCount < 1) {
            this._isLoading.next(false);
        }
    }
}
